import React, { useEffect, useState } from 'react';

// Kurze, warme, kindgerechte Kurt-Sprüche für die Warte-/Mute-Anzeige.
// Werden im Schüler-Videofeld gezeigt, solange kein Lehrervideo läuft.
const KURT_QUOTES = [
  'Gleich geht es los – ich freu mich auf dich! 😊',
  'Du schaffst das, ich bin bei dir!',
  'Mach es dir gemütlich, es geht gleich weiter.',
  'Schön, dass du da bist!',
  'Hol dir kurz etwas zu trinken – gleich starten wir.',
  'Bleib dran, du machst das großartig!',
  'Ein kleiner Moment noch, dann geht es weiter.',
  'Ich bin stolz auf dich – weiter so!',
  'Atme einmal tief durch, gleich geht es los.',
  'Jede Frage bringt dich weiter – super!',
  'Lernen macht Spaß, wenn wir zusammen sind!',
  'Gleich bin ich wieder für dich da.',
];

function pickNext(current) {
  if (KURT_QUOTES.length <= 1) return 0;
  let next = current;
  while (next === current) {
    next = Math.floor(Math.random() * KURT_QUOTES.length);
  }
  return next;
}

function KurtWaiting() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * KURT_QUOTES.length));

  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => pickNext(prev));
    }, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="kurtWaiting" role="status" aria-live="polite">
      {/* key=index remountet die Blase → CSS-Pop-Animation läuft bei jedem Spruch neu */}
      <div key={index} className="kurtBubble">
        {KURT_QUOTES[index]}
      </div>
      <img
        className="kurtImage"
        src="/images/kurt_winkend.png"
        alt="Kurt, dein Lernassistent, winkt dir zu"
        draggable="false"
      />
    </div>
  );
}

export default KurtWaiting;
